import { useMutation, useQueryClient } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

type AcceptTermsResponse = {
  redirectUrl?: string
}

export function useAcceptTerms() {
  const queryClient = useQueryClient()

  return useMutation<AcceptTermsResponse, unknown, void>({
    mutationFn: async () => {
      const response = await fetcher(
        "/Verification/AcceptTerms",
        {
          method: "PUT",
        },
        {
          useAccessToken: true,
        }
      )

      const responseJson = await response.json()

      return responseJson
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["VerificationStatus"] })
    },
  })
}
